<!--
  Otros apartados: filas con icono a la izquierda (como el sidebar) y el valor o
  la flecha a la derecha. Estilos en offsidebar.component.scss.
-->
<section class="off-section">
  <h6 class="off-section-title">{{ "offsidebar.other-configuration.title" | translate }}</h6>
  <p class="off-section-subtitle">{{ "offsidebar.other-configuration.subtitle" | translate }}</p>

  <button type="button" class="off-item off-item-link" (click)="getLastVersion()">
    <span class="off-item-label"><em class="fa fa-info-circle off-item-icon"></em>{{ "tables.version" | translate }}</span>
    <span class="off-item-value">{{ currentVersion }}</span>
  </button>

  <button type="button" class="off-item off-item-link" (click)="toggleFullScreen()">
    <span class="off-item-label"><em class="fa fa-expand off-item-icon"></em>{{ "clients.ponds-comparison.expand" | translate }}</span>
  </button>

  <!-- Alimentadores seleccionados al cerrar el modal -->
  <div class="off-item">
    <label class="off-item-label mb-0" for="keepDevicesSelectedSwitch">
      <em class="fa fa-check-square off-item-icon"></em>
      {{ "offsidebar.other-configuration.keep-devices-selected" | translate }}
    </label>
    <div class="custom-control custom-switch">
      <input
        type="checkbox"
        class="custom-control-input"
        id="keepDevicesSelectedSwitch"
        [checked]="storageService.localValue.keep_devices_selected"
        (change)="toggleKeepDevicesSelected()"
      />
      <label class="custom-control-label" for="keepDevicesSelectedSwitch"></label>
    </div>
  </div>

  <a class="off-item off-item-link" [routerLink]="'/lock'">
    <span class="off-item-label"><em class="fa fa-lock off-item-icon"></em>{{ "pages.lock.change-password" | translate }}</span>
    <em class="fa fa-chevron-right off-item-chevron"></em>
  </a>

  <a class="off-item off-item-link" [routerLink]="'/sesiones'">
    <span class="off-item-label"><em class="fa fa-user-lock off-item-icon"></em>{{ "admin.access-tokens.close-all-sessions" | translate }}</span>
    <em class="fa fa-chevron-right off-item-chevron"></em>
  </a>

  <a class="off-item off-item-link" [routerLink]="'/contacts'">
    <span class="off-item-label"><em class="fa fa-users off-item-icon"></em>{{ "clients.contacts.title" | translate }}</span>
    <em class="fa fa-chevron-right off-item-chevron"></em>
  </a>

  <a
    class="off-item off-item-link"
    [routerLink]="'/bugs'"
    routerLinkActive="setting-active"
    *ngIf="storageService.isAdmin()"
  >
    <span class="off-item-label"><em class="fa fa-bug off-item-icon"></em>{{ "offsidebar.other-configuration.mobile-errors" | translate }}</span>
    <em class="fa fa-chevron-right off-item-chevron"></em>
  </a>

  <!-- Menu lateral solo con iconos (solo escritorio) -->
  <div class="off-item only-desktop">
    <label class="off-item-label mb-0" for="keepMenuCollapsedSwitch">
      <em class="fa fa-bars off-item-icon"></em>
      {{ "offsidebar.other-configuration.keep-menu-collapsed" | translate }}
    </label>
    <div class="custom-control custom-switch">
      <input
        type="checkbox"
        class="custom-control-input"
        id="keepMenuCollapsedSwitch"
        [checked]="settings.getLayoutSetting('isCollapsedText')"
        (change)="toggleCollapsedMenu()"
      />
      <label class="custom-control-label" for="keepMenuCollapsedSwitch"></label>
    </div>
  </div>
</section>
